import React from 'react';
import { Box, Types } from '@fiverr-private/theme';

export const COLORS_BY_TYPE: {
    [status: string]: {
        color: Types.BoxType['color'];
        backgroundColor: Types.BoxType['backgroundColor'];
    };
} = {
    neutral: {
        color: 'grey_1200',
        backgroundColor: 'grey_400',
    },
    info: {
        color: 'blue_1100',
        backgroundColor: 'blue_200',
    },
    warning: {
        color: 'yellow_1200',
        backgroundColor: 'yellow_200',
    },
    success: {
        color: 'green_1100',
        backgroundColor: 'green_200',
    },
    error: {
        color: 'red_1100',
        backgroundColor: 'red_200',
    },
    special: {
        color: 'pink_1100',
        backgroundColor: 'pink_200',
    },
};

export interface StatusProps {
    type: keyof typeof COLORS_BY_TYPE;
    children: React.ReactNode;
}

export const Status = ({ type = 'neutral', children }: StatusProps) => (
    <Box
        borderRadius="sm"
        minHeight="20px"
        display="flex"
        alignItems="center"
        paddingX="2"
        width="fit-content"
        letterSpacing="0.5px"
        fontSize="b_xxs"
        lineHeight="b_xs"
        fontWeight="bold"
        userSelect="none"
        {...COLORS_BY_TYPE[type]}
    >
        {children}
    </Box>
);
